<div class="app-versions-container">
    <div class="d-flex align-items-center mb-4">
        <h4 class="flex-grow-1 mb-0">App Versions</h4>
        <button
            id="btn-bump-all"
            mat-raised-button
            color="primary"
            class="btn-bump-all"
            (click)="bumpAllAndDeploy()"
            [disabled]="bulkInProgress || dataSource.data.length === 0"
        >
            <mat-icon class="material-symbols-outlined me-1">rocket_launch</mat-icon>
            Bump All & Deploy
        </button>
    </div>

    @if (bulkResults) {
        <div class="bulk-results mb-3 d-flex align-items-center gap-2">
            <mat-icon class="material-symbols-outlined text-success">check_circle</mat-icon>
            <span>{{ bulkResults.success }} succeeded</span>
            @if (bulkResults.failed > 0) {
                <mat-icon class="material-symbols-outlined text-danger">error</mat-icon>
                <span>{{ bulkResults.failed }} failed</span>
            }
        </div>
    }

    <div class="table-container d-flex p-3 w-100">
        <div class="bulk-controls d-flex align-items-center gap-2 mb-3">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bulk-version-field">
                <mat-label>Set version for all apps</mat-label>
                <input
                    id="input-bulk-set-version"
                    matInput
                    [imask]="versionMask"
                    [ngModel]="bulkSetVersion"
                    (ngModelChange)="onBulkVersionChange($event)"
                    placeholder="x.y.z"
                    [disabled]="bulkInProgress"
                />
            </mat-form-field>
            <button
                id="btn-apply-to-all-deploy"
                mat-raised-button
                color="primary"
                class="btn-apply-deploy"
                (click)="applyToAllAndDeploy()"
                [disabled]="!isBulkVersionValid || bulkInProgress || dataSource.data.length === 0"
                matTooltip="Set this version on all apps and trigger deployments"
            >
                <mat-icon class="material-symbols-outlined me-1">deployed_code_update</mat-icon>
                Apply to All & Deploy
            </button>
        </div>
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 w-100">
            <ng-container matColumnDef="organizationName">
                <th mat-header-cell *matHeaderCellDef>Organization Name</th>
                <td mat-cell *matCellDef="let row">{{ row.organizationName }}</td>
            </ng-container>

            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>ID</th>
                <td mat-cell *matCellDef="let row">
                    <span class="id-cell" [matTooltip]="row.id">{{ row.id }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="appVersion">
                <th mat-header-cell *matHeaderCellDef>App Version</th>
                <td mat-cell *matCellDef="let row">
                    <mat-form-field class="version-field" appearance="outline" subscriptSizing="dynamic">
                        <input
                            id="input-app-version-{{row.id}}"
                            matInput
                            [imask]="versionMask"
                            [ngModel]="row.editVersion"
                            (ngModelChange)="onEditVersionChange(row, $event)"
                            [disabled]="row.status === 'loading' || bulkInProgress"
                            placeholder="0.0.0"
                        />
                        @if (row.editVersion && !row.isEditVersionValid) {
                            <mat-error>Invalid version (use x.y.z)</mat-error>
                        }
                    </mat-form-field>
                </td>
            </ng-container>

            <ng-container matColumnDef="appVersionChangedAt">
                <th mat-header-cell *matHeaderCellDef>Last Version Update</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.appVersionChangedAt ? (row.appVersionChangedAt | date: 'medium') : 'N/A' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let row">
                    <div class="actions-cell d-flex align-items-center gap-1">
                        @if (row.status === 'loading') {
                            <mat-spinner diameter="24"></mat-spinner>
                        } @else {
                            @if (row.status === 'success') {
                                <mat-icon class="material-symbols-outlined status-success">check_circle</mat-icon>
                            }
                            @if (row.status === 'error') {
                                <mat-icon class="material-symbols-outlined status-error">error</mat-icon>
                            }
                            @if (row.editVersion !== row.appVersion) {
                                <button
                                    id="btn-save-version-{{row.id}}"
                                    mat-button
                                    color="primary"
                                    (click)="saveVersion(row)"
                                    [disabled]="!row.isEditVersionValid || bulkInProgress"
                                    matTooltip="Save version and trigger deploy"
                                >
                                    Save
                                </button>
                            }
                            <button
                                id="btn-bump-deploy-{{row.id}}"
                                mat-raised-button
                                color="primary"
                                class="btn-bump"
                                (click)="bumpAndDeploy(row)"
                                [disabled]="bulkInProgress"
                                matTooltip="Increment version +0.0.1 and deploy"
                            >
                                <mat-icon class="material-symbols-outlined">upgrade</mat-icon>
                                Bump & Deploy
                            </button>
                        }
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [class.row-success]="row.status === 'success'"
                [class.row-error]="row.status === 'error'"
            ></tr>
        </table>
    </div>
</div>
